import { html, TemplateResult } from "lit-html";
import { InputComponent, ButtonComponent, LabelComponent } from "@components/common";


const WhatField = (params: IWhatField): TemplateResult => {
  const {
    formData: {
      what: {
        value: whatValue
      },
      where: {
        value: whereValue
      }
    },
    messages: {
      SearchWhat,
      RegistrationWhat
    },
    loading,
    handleWhatInput,
    handleClearWhatInput,
  } = params;

  const whatInputClasses = (): string =>
    `jr-input jr-input-material ${!whatValue && !whereValue ? 'jr-input--invalid' : ''}`;

  return html`
    <div class="proposal-form__field">
    ${InputComponent({
    type: 'text',
    name: 'what',
    cssClasses: whatInputClasses(),
    placeholder: SearchWhat,
    value: whatValue,
    options: {
      disabled: loading,
      autofocus: !whatValue && !whereValue && !loading
    },
    eventHandlers: {
      onInput: handleWhatInput
    }
  })}
      ${ButtonComponent({ type: 'button', cssClasses: 'clear-button', eventHandlers: { onClick: handleClearWhatInput } })}
      ${LabelComponent({ cssClasses: 'proposal-form__label', labelText: RegistrationWhat })}
    </div>`;
}

export default WhatField;